export default __webpack_public_path__ + "static/IMG_4999-cc342fd581b7a9a31a30178dad76f493.jpg";